import React, { useRef } from 'react';
import styled from 'styled-components';
import { zoomPolygonsIntoView } from 'helpers/googleMap/zoomPolygonsIntoView';

// controllers
import CollapsableController from 'controllers/CollapsableController';
import AddressController from 'controllers/AddressController';
import TractInformationController from 'controllers/TractInformationController';
import ZoomController from 'controllers/ZoomController';
import ActivePolygonsController from 'controllers/ActivePolygonsController';

// components
import WithCollapsable from 'HOC/WithCollapsable';
import Card from 'components/Card';
import { TextInput, Description } from 'components/StyledComponents'
import Map from './Map';
import Calculator from 'components/Calculator'
import RegionalCenter from './RegionalCenter';
import { H3 } from 'components/typography/H3';
import { BtnGray as CBtnGray } from './StyledComponents'

// styled components
const CollapsedContentWrap = styled.div`
  padding: 20px;
  background-color: white;
  height: 100%;
  position: relative;
`;

const BtnGray = styled(CBtnGray)`
  margin-bottom: 10px;
  border-radius: 2px;
  position: absolute;
  top: 2px;
  left: 3px;
`

// functions

export default function MainCard(props) {
  const input = useRef(null);
  
  const {
    addressController = AddressController,
    polygonsController = ActivePolygonsController,
    tractController = TractInformationController,
    zoomController = ZoomController,
    collapsableController = CollapsableController,
  } = props;

  const { fetchData, clearData, tractData } = tractController();
  const { polygons, updatePolygons, clearPolygons } = polygonsController();
  const { address, updateAddress, updateFormattedAddress } = addressController();
  const { updateZoom } = zoomController();
  const collapsableData = collapsableController();

  function deselectTract() {
    collapsableData.close();
    clearData();
    clearPolygons();
  }

  return (
    <>
      <WithCollapsable
        controllerData={collapsableData}
        content={({ open: openDetails, isOpened }) => (
          <Card styles={{
            padding: '20px', 
            borderRight: isOpened ? '1px solid #c7c7c7 !important' : 'unset'
          }}>
            <div align="center">
              
              <H3 style={{marginTop: 20}}>
                Determine EB-5 Job Creation for Your Project
              </H3>
              <br/>
              
              <TextInput
                ref={input}
                value={address.formatted_address}
                onChange={(e) => updateFormattedAddress(e.target.value)}
                placeholder="Enter your EB-5 project’s address here or click on the map"
              />
              
              <Description>
                Every EB-5 project must create at least 10 new full-time jobs for each EB-5 applicant who invests into the project.
                <br/><br/>
                This tool estimates your project’s EB-5 eligible job creation, which determines how much EB-5 investment capital your project can accept.
              </Description>

              {/* MAP */}
              <Map
                input={input}
                polygons={polygons.slice(0, 1)}
                adjacents={ () => {} }
                isOpened={isOpened}
                onAutocomplete={(place, google, map) => {
                  updateAddress(place);
                  openDetails();
                  fetchData(
                    place,
                    (tractData) => {
                      const activePolygons = updatePolygons(tractData);
                      zoomPolygonsIntoView(google, map, activePolygons.map(polygon => polygon.paths));
                      updateZoom(map.getZoom());
                    }
                  );
                }}
                deselectTract={() => {
                  collapsableData.close();
                  clearData();
                  clearPolygons();
                }}
              />
            </div>
          </Card>
        )}
        collapsedContent={({ isOpened }) => (
          <CollapsedContentWrap>
            <BtnGray
              small="true"
              onClick={deselectTract}
            >X Close</BtnGray>
            <Calculator
              isOpened={isOpened}
              address={address}
              tractData={tractData}
            />
          </CollapsedContentWrap>
        )}
      />
      {
        tractData &&
        <RegionalCenter rcName={tractData.rcName} rcLink={tractData.rcLink} />
      }
    </>
  );
};
